<template>
	<div id="home-page">

		<section class="banners-section-bv" v-if="bootstrapVueMode">
			<b-carousel :interval="3000"
				v-model="slide"
				controls
				indicators
				background="#ababab">
					<b-carousel-slide v-for="(banner, bhoInx) in banners" :key="'bv-' + bhoInx">
						<template #img>
							<div class="img-holder" @click="openURL(banner.url)">
								<!-- <api-img class="all" :comp="banner.imagenes_id_small" size="550/550" width="100%" /> -->
								<api-img class="img-small" @click="openURL(banner.url)" :comp="banner.imagenes_id_small" size="1024/1024" width="100%" />
								<api-img class="img-mid" @click="openURL(banner.url)" :comp="banner.imagenes_id_mid" size="1320/720" width="100%" />
								<api-img class="img-full" @click="openURL(banner.url)" :comp="banner.imagenes_id_full" size="2880/825" width="100%" />
							</div>
						</template>
					</b-carousel-slide>
			</b-carousel>
		</section>

		<section class="banners-section" v-else>
			<swiper class="swiper" :options="swiperOption">

				<swiper-slide v-for="(banner, bhoInx) in banners" :key="'bho-' + bhoInx">
					<!-- {{ banner }} -->
					  <div class="img-holder" @click="openURL(banner.url)">
						  <api-img class="img-small" :comp="banner.imagenes_id_small" size="550/550" width="100%" />
						  <api-img class="img-mid" :comp="banner.imagenes_id_mid" size="660/360" width="100%" />
						  <api-img class="img-full" :comp="banner.imagenes_id_full" size="1920/550" width="100%" />
					  </div>
					<!-- <img :src="banner.img"> -->
					<!-- <img class="img-mobile" :src="banner.imgMob"> -->
				</swiper-slide>

				<div class="swiper-button-prev" slot="button-prev"></div>
				<div class="swiper-button-next" slot="button-next"></div>
			</swiper>
		</section>

		<section class="info-section">
			<div class="container oversized-container">
				<div class="row">
					<div class="col-12 col-titles">
						<h2 class="title">
							<!-- Una plataforma muy sencilla de utilizar -->
							 {{ 'landing-side' | static-title }}
						</h2>
						<h6 class="subtitle">
							<!-- Recibe asistencia rápidamente. -->
							 {{ 'landing-side' | static-content }}
						</h6>
					</div>
				</div>

				<div class="row justify-content-center">
					<div class="col-sm-6 col-lg-4 col-opt" v-for="n in ['landing-side-1', 'landing-side-2', 'landing-side-3']" :key="'opt-' + n">
						<div class="d-block">
							<div class="circle">
								<static-image :hash="n" />
							</div>

							<h3 class="num">{{ n | static-title }}</h3>
							<p>
								{{ n | staticContent }}
							</p>
						</div>
					</div>
				</div>

				<!-- <div class="row justify-content-center">
					<div class="col-sm-6 col-lg-4 col-opt">
						<div class="d-block">
							<div class="circle">
								<img src="/public/images/pages/home/step-1.jpg">
							</div>

							<h3 class="num">1</h3>
							<p>
								Encuentra productos de forma efectiva y en segundos.
							</p>
						</div>
					</div>

					<div class="col-sm-6 col-lg-4 col-opt">
						<div class="d-block">
							<div class="circle">
								<img src="/public/images/pages/home/step-2.jpg">
							</div>

							<h3 class="num">2</h3>
							<p>
								Explora a detalle cada pieza que necesites antes de comprarla.
							</p>
						</div>
					</div>

					<div class="col-sm-6 col-lg-4 col-opt">
						<div class="d-block">
							<div class="circle">
								<img src="/public/images/pages/home/step-3.jpg">
							</div>

							<h3 class="num">3</h3>
							<p>
								Pídela, paga de forma segura y recibe en menos de 1 hora y media.
							</p>
						</div>
					</div>
				</div> -->
			</div>
		</section>

		<section class="newsletter-section">
			<h2>Suscríbete a nuestro Newsletter</h2>

			<b-form @submit="onSubmit">
				<b-form-group>
					<b-form-input v-model="form.email" type="email" required
						placeholder="Correo electrónico"></b-form-input>
				</b-form-group>

				<b-button type="submit" class="btn-send">Enviar</b-button>
			</b-form>
		</section>

	</div>
</template>

<script>
import apiImgPristine from '@@/shared/api-img-pristine.vue'
export default {

	props: {
		bootstrapVueMode: {
			type: Boolean,
			default: true
		}
	},

	components: {
		apiImg: apiImgPristine,
	},

	computed: {
		banners() {
			return this.$store.getters.catalogBannersWeb;
		}
	},
	data() {
		return {

			slide: 0,
        	sliding: null,

			form: {
				email: null
			},

			// == Carousels options ==
			swiperOption: {
				loop: false,
				effect: 'fade',
				speed: 750,

				autoplay: true,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			}
			// == ==
		}
	},

	methods: {
		openURL(url) {
			try {
				if (!!url)
					window.open(url, '_blank');
				else
					return;
			} catch (E) {
				console.log('E', E);
				return;
			}
		},
		makeToast(variant = null, msg, title) {
			this.$bvToast.toast(msg, {
				title: title,
				variant: variant,
				solid: true,
				toaster: 'b-toaster-top-right',
				appendToast: true
			});
		},

		onSubmit(evt) {
			evt.preventDefault();
			var r = confirm("¿Deseas suscribirte al Newsletter?");
			if (r == true) {
				axios.post(tools.url("/newsletter"), this.form).then((response) => {
					this.makeToast('default', response.data.response, 'Correo registrado');
					this.form = {
						email: null
					};
				}).catch((error) => {
					// console.log(error.response);
					let errors = error.response.data;
					// console.log(errors);
					this.makeToast('danger', error.response.data.email, 'Error');
				});
			}
		},
	}
}
</script>
